import consola from 'consola';
import * as Sentry from '@sentry/vue';
import { get } from '@/js/api/sourcer';
import STATUS from '@/store/status';
import Config from '@/js/config';
import Cookies from 'js-cookie';

const SET_STATUS = 'SET_STATUS';
const START_LOADING = 'START_LOADING';
const FINISH_LOADING = 'FINISH_LOADING';

const State = {
  value: {},
  status: STATUS.NOT_LOADED,
  operation: undefined,
};

// getters
const Getters = {
  getUser: (state) => state.value,
  getIsUserSelfServe: (state) => {
    if (!state.value.experiments) return false;
    return state.value.experiments.enable_self_serve_lean_test || false;
  },
  getIsUserV2: () => {
    return false;
  },

  getIsSuperAdmin: (state) => {
    return !!state.value.is_super_admin;
  },
};

const Operation = async () => {
  try {
    const response = await get(`${Config.env.API_URL}users/settings`);
    consola.info(response);
    Sentry.setUser({ email: response.data.email, id: response.data.id });

    if (response.data.email.includes('hirefly.ai')) {
      Cookies.set('hirefly_user', 'true', {
        path: '',
        domain: '.hirefly.ai',
      });
    } else {
      Cookies.set('hirefly_user', 'false', {
        path: '',
        domain: '.hirefly.ai',
      });
    }

    return response.data;
  } catch (error) {
    consola.error(error);
    consola.info('Error fetching user');
    localStorage.removeItem('session');
    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    localStorage.removeItem('email');
    localStorage.removeItem('profile_picture');
    localStorage.removeItem('product_type');
    localStorage.removeItem('authorized_products');
    Cookies.remove('site_version');
    Cookies.remove('hirefly_user', {
      path: '',
      domain: '.hirefly.ai',
    });
    Sentry.setUser(null);
    window.location.reload();
  }
  return {};
};

// actions
const Actions = (operation) => ({
  async LOAD({ state, commit }, payload) {
    if (!(payload && payload.force)) {
      if (state.status === STATUS.LOADED) {
        return state.value;
      }

      // If there is a pending operation, wait it finish, and return value.
      if (state.status === STATUS.LOADING) {
        const response = await state.operation;
        return response;
      }
    }

    commit(START_LOADING, { operation });
    commit(FINISH_LOADING, { value: await state.operation });
    return state.value;
  },
});

// mutations
const Mutations = {
  [SET_STATUS](state, { status }) {
    consola.info(`[${state.constructor.name}]:SetStatus ${status}`);
    state.status = status;
  },
  [START_LOADING](state, { operation }) {
    consola.info(`[${state.constructor.name}]:START_LOADING`);
    consola.info(operation);
    state.operation = operation();
    state.status = STATUS.LOADING;
  },
  [FINISH_LOADING](state, { value }) {
    console.log('HERES THE VALUE');
    console.log(value);
    if (!value) return;
    consola.info(`[${state.constructor.name}]:FINISH_LOADING`);
    consola.info(value);
    state.value = value;
    state.status = STATUS.LOADED;
  },
};

export default {
  namespaced: true,
  state: State,
  getters: Getters,
  actions: Actions(Operation),
  mutations: Mutations,
};
